import type { AuditLogAction, AuditLogDomain } from "./auditLogSchemas";

export type AuditLogFilters = {
    from?: string;
    to?: string;
    action?: AuditLogAction[];
    action_not?: AuditLogAction[];
    actorType?: string[];
    actorType_not?: string[];
    actorId?: string[];
    actorId_not?: string[];
    entityType?: string[];
    entityType_not?: string[];
    entityId?: string;
    domain?: AuditLogDomain;
    rootType?: string[];
    rootType_not?: string[];
    rootId?: string;
    q?: string;
};

export const emptyAuditLogFilters: AuditLogFilters = {};

export const AUDIT_LOG_KEPT_KEYS = ["action", "actorType", "actorId", "entityType", "rootType"] as const;

export type AuditLogKeptKey = (typeof AUDIT_LOG_KEPT_KEYS)[number];

export type AuditLogDroppedKey = `${AuditLogKeptKey}_not`;

export const droppedKeyOf = (key: AuditLogKeptKey): AuditLogDroppedKey => `${key}_not`;

export const AUDIT_LOG_MULTI_VALUE_KEYS = [
    ...AUDIT_LOG_KEPT_KEYS,
    ...AUDIT_LOG_KEPT_KEYS.map(droppedKeyOf),
] as const satisfies readonly (AuditLogKeptKey | AuditLogDroppedKey)[];

export type AuditLogMultiValueKey = AuditLogKeptKey | AuditLogDroppedKey;

const SINGLE_VALUE_KEYS = ["from", "to", "entityId", "domain", "rootId", "q"] as const satisfies readonly Exclude<
    keyof AuditLogFilters,
    AuditLogMultiValueKey
>[];

export const buildAuditLogParams = (filters: AuditLogFilters): Record<string, string> => {
    const params: Record<string, string> = {};

    SINGLE_VALUE_KEYS.forEach((key) => {
        const value = filters[key];

        if (value !== undefined && value.trim() !== "") {
            params[key] = value;
        }
    });

    AUDIT_LOG_MULTI_VALUE_KEYS.forEach((key) => {
        const values = filters[key];

        if (values !== undefined && values.length > 0) {
            params[key] = values.join(",");
        }
    });

    return params;
};

export const countActiveAuditLogFilters = (filters: AuditLogFilters): number =>
    Object.keys(buildAuditLogParams(filters)).length;
